export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["दिखाया गया:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["कुल"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्रति पृष्ठ"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["दिखाएं"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["परिणाम"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["से"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["व्यापार"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["व्यापार"])}
}